import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { appStore } from '../../../services/appStore';
import { useAiOutreachTracking } from '../AIOutreachPanel/useAiOutreachTracking';

import { StyledAiOutreachButton, StyledText } from './styles';

type AiOutreachButtonProps = {
  domain: string;
  companyName: string;
};

export const AiOutreachButton = ({ domain, companyName }: AiOutreachButtonProps) => {
  const { t } = useTranslation();
  const tracking = useAiOutreachTracking();

  const handleClick = () => {
    tracking.trackOpenFromOverview(domain);
    appStore.setAiOutreachOpen(true, domain, companyName);
  };

  return (
    <StyledAiOutreachButton variant="flat" data-automation="ai-outreach-button" onClick={handleClick}>
      <SWReactIcons iconName="craft-email" size="xs" iconColor={colorsPalettes.carbon[0]} />
      <StyledText>{t('company.overview.ai-outreach.button')}</StyledText>
    </StyledAiOutreachButton>
  );
};
